<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 w-100">
        <div class="d-flex align-items-center gap-2">
          <h6 class="modal-title" i18n>Send Document</h6>
        </div>
        <div class="flex-fill"></div>
        <button class="btn btn-secondary-light" (click)="prevStep()" [disabled]="isSending" *ngIf="hasPrev()">
          <i class="far fa-arrow-left"></i> <ng-container i18n>Back</ng-container>
        </button>
        <button
          class="btn btn-secondary-info"
          (click)="nextStep()"
          [disabled]="isSending || isProcessing"
          *ngIf="currentStep !== steps.DocumentDetails"
        >
          <ng-container i18n>Next</ng-container>
          <i class="far fa-arrow-right ml-1 mr-0" *ngIf="!isProcessing"></i>
          <i class="far fa-spin fa-spinner ml-1 mr-0" *ngIf="isProcessing"></i>
        </button>
        <button class="btn btn-warning" *ngIf="currentStep === steps.PlaceFields" (click)="onPreview()">
          <i class="far fa-eye"></i> <ng-container i18n>Preview</ng-container>
        </button>
        <ng-container *ngIf="onlyMeSigner && !isDocumentType; else sendBtn">
          <button
            class="btn btn-secondary-info"
            (click)="onSignIt()"
            [disabled]="isSending"
            *ngIf="currentStep === steps.DocumentDetails"
          >
            <i [ngClass]="isSending ? 'far fa-spin fa-spinner' : 'fas fa-signature'"></i>
            <ng-container i18n>Sign</ng-container>
          </button>
        </ng-container>
        <ng-template #sendBtn>
          <button
            class="btn btn-secondary-info"
            (click)="onSend()"
            [disabled]="isSending"
            *ngIf="currentStep === steps.DocumentDetails"
          >
            <i [ngClass]="isSending ? 'far fa-spin fa-spinner' : 'fas fa-paper-plane'"></i>
            <ng-container i18n>Send</ng-container>
          </button>
        </ng-template>
      </div>
      <a (click)="close()" class="cstm-close" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body p-0" #modalBody>
      <mat-stepper [linear]="true" #stepper class="m-3">
        <mat-step i18n-label label="Select Document" [state]="stepper.selectedIndex > 0 ? 'done' : 'number'">
          <ng-template matStepContent>
            <app-upload-template [form]="contractBasicForm" [isOnetime]="true"></app-upload-template>
          </ng-template>
        </mat-step>
        <mat-step
          i18n-label
          label="Add Signer"
          [optional]="true"
          [state]="stepper.selectedIndex > 1 ? 'done' : 'number'"
        >
          <ng-template matStepContent>
            <div class="container-box p-3">
              <div class="bg-active2 p-3 rounded">
                <div class="d-grid gap-3 mb-3" style="grid-template-columns: 2fr 1fr">
                  <div class="d-flex align-items-end">
                    <div class="text-semi-bold">
                      <span class="badge badge-circle badge-light border text-md">3</span>
                      <ng-container i18n> Who will be signing the document?</ng-container>
                    </div>
                    <a
                      href="javascript:;"
                      i18n-matTooltip
                      matTooltip="Automatically add yourself as the only signer of this document. You will be taken to the next step to prepare the document for signing."
                      (click)="signersFormCom.addMeAsOnlySigner(); nextStep()"
                      class="ml-auto btn btn-secondary-info"
                    >
                      <i class="far fa-check"></i> <ng-container i18n>I am the only signer</ng-container>
                    </a>
                  </div>
                  <div class="d-flex align-items-end text-semi-bold" i18n>Signing Order</div>
                </div>
                <app-signers-without-role
                  #signersFormCom
                  [form]="signersForm"
                  [defaultSigner]="defaultSigner"
                  [templateType]="getFieldValue | call : contractBasicForm : 'type'"
                  [isSignerCustomizable]="(getFieldValue | call : contractBasicForm : 'type') !== templateTypes.Form"
                >
                </app-signers-without-role>
              </div>
            </div>
          </ng-template>
        </mat-step>
        <mat-step
          i18n-label
          label="Place Fields"
          [optional]="true"
          [state]="stepper.selectedIndex > 2 ? 'done' : 'number'"
        >
          <ng-template matStepContent>
            <app-place-fields-form
              #placeFieldsFormCom
              [isOnetime]="true"
              [showStep]="true"
              [form]="fieldsForm"
              [templateType]="getFieldValue | call : contractBasicForm : 'type'"
              [templateFileUrl]="mergedDocumentFileUrl"
              [roles]="getRoles | call : signersForm"
              [style.height.px]="modalBody.offsetHeight - 90"
            ></app-place-fields-form>
          </ng-template>
        </mat-step>
        <mat-step i18n-label label="Template Details" [state]="stepper.selectedIndex > 3 ? 'done' : 'number'">
          <ng-template matStepContent>
            <div class="container-box p-3">
              <div class="text-semi-bold mb-4">
                <span class="badge badge-circle badge-light border text-md">3</span>
                <ng-container i18n> Finalize the details for this document.</ng-container>
              </div>
              <app-send-contract-info-form
                [form]="contractInfoForm"
                [fillBeforeSendingFields]="getFillBeforeSendingFields | call : fieldsForm"
                [isDocument]="true"
                [signInApp]="onlyMeSigner && !isDocumentType"
                [isInquiryRequired]="
                  isBookingRequired
                    | call
                      : sendTemplateService
                      : (getFieldValue | call : contractBasicForm : 'type')
                      : placeFieldsFormCom.getFieldsConfig()
                "
              >
              </app-send-contract-info-form>
            </div>
          </ng-template>
        </mat-step>
        <ng-template matStepperIcon="done">
          <i class="cs-icon cs-icon-check2 text-xs"></i>
        </ng-template>
        <ng-template matStepperIcon="edit">
          <i class="cs-icon cs-icon-check2 text-xs"></i>
        </ng-template>
      </mat-stepper>
    </div>
  </div>
</div>
